import { DatePicker } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SDatePicker = styled(DatePicker)`
  &.ant-picker {
    .ant-picker-input {
      input {
        font-weight: 400 !important;

        &::placeholder {
          font-weight: 400 !important;
        }
      }
    }
  }
`;
